export default __webpack_public_path__ + "static/media/declined.b466a490.svg";